class AppConfig {
    static version = '1.1 (126)'
    static skipOfflineCache = false
    static baseUrl = ''
}

export default AppConfig
